/* eslint-disable */
import React, {
  createContext, useContext, useState, useCallback,
} from 'react';
import toastImage from '../assets/images/toast.png'

export const ToastContext = createContext();

export function ToastContextProvider({ children }) {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  const showToast = useCallback((text, duration = 3000) => {
    setToast(text);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {visible && toast && (
        <div
          className="fixed bottom-20 left-1/2 transform -translate-x-1/2 bg-[#232323] text-white px-4 py-2 rounded shadow-lg flex items-center space-x-5 z-30 slideup-animation w-auto max-w-md lg:bottom-24"
        >
          <div className="bg-gray-700 text-white p-2 rounded-full flex items-center justify-center w-11">
            <img width={500} height={500} src={toastImage} alt="toast-icon" />
          </div>
          <span>{toast}</span>
        </div>
      )}
    </ToastContext.Provider>
  );
}

// export function useToast() {
//   return useContext(ToastContext);
// }